import { render, staticRenderFns } from "./ReserveCheck.vue?vue&type=template&id=2f04a69a&scoped=true&lang=pug"
import script from "./ReserveCheck.vue?vue&type=script&lang=js"
export * from "./ReserveCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f04a69a",
  null
  
)

export default component.exports